// tenant -> site title overrides
const TENANT_TITLES = {
  'luxefarer.travelwits.com': 'Luxefarer | Travel Portal',
  'bookings.nicer.travel': 'Nicer Travel',
  'microsoft-evp.travelink.com': 'Microsoft Employee Vacation Program',
};
export default TENANT_TITLES;
